import { OptionalToNullable } from "../utils";

export type DbCreateInputOmit<T> = Omit<T, "id" | "createdAt" | "updatedAt">;

export type DbUpdateInputOmit<T> = Omit<T, "createdAt" | "updatedAt" | "persistentId">;

export type DbUpdate<T extends { id: string }> = Partial<OptionalToNullable<DbUpdateInputOmit<Omit<T, "id">>>> &
  Pick<T, "id">;

export function zodCreateInputOmit() {
  return {
    id: true,
    createdAt: true,
    updatedAt: true,
  } as const;
}

export function zodUpdateInputOmit() {
  return {
    id: true,
    createdAt: true,
    updatedAt: true,
    persistentId: true,
  } as const;
}
